import { useNavigate } from "react-router-dom";
import TableWrapper from "../../../../component/TableWrapper";
import classes from "../../style.module.scss";
import ArrowBackIosOutlinedIcon from '@mui/icons-material/ArrowBackIosOutlined';
import Button from "../../../../component/Button";

const RedeemedFirstTimeList = (props) => {
    const { metricList, isLoading, sortConfig, setSortConfig, page, setPage, setIsGeneratingPdf, isGeneratingPdf, ListType, setActiveTab, activeTab } = props;
    const navigate = useNavigate();

    const userHeader = [
        { label: "User Name", sortable: "name" },
        { label: "Email", sortable: "email" },
        { label: "Redeemed On", sortable: "redeemedOn" },
        { label: "Delivery Address", sortable: "address" },
        { label: "Total Points", sortable: "totalPoints" },
        { label: "Rewards Title", sortable: "title" },
    ];

    const handleData = (keyValue, defaultValue = "-", className = "") => {
        return <td className={`${className}`}>{keyValue || defaultValue}</td>;
    };

    const redirectBack = () => {
        navigate('/admin/appAnalytics')
    }

    const generatePdf = () => {
        setIsGeneratingPdf(true)
    }

    return (
        <div className={`eventWrapper`}>
            <div className={`mt-2 mb-5 ${classes.adminTableWrapper}`}>
                <div className={`layout-title flex items-center justify-between mb-6`}>
                    <div className="flex items-center">
                        <div className='mr-2 flex items-center cursor-pointer' onClick={() => redirectBack()}>
                            <ArrowBackIosOutlinedIcon />
                        </div>
                        <div>Reward Redeemed First Time</div>
                    </div>
                    <div className="actions">
                        <Button
                            disabled={isGeneratingPdf}
                            text={"Download"}
                            onClick={generatePdf}
                            style={{
                                lineHeight: "normal",
                                height: "40px",
                                padding: "0px 20px",
                                fontSize: "16px",
                            }}
                        />
                    </div>
                </div>
                <div className={`${classes.userHeaderList} w-[100%] flex items-center cursor-pointer`}>
                    {ListType?.map((title) => <div className={`${classes.userTab} ${activeTab === title ? classes.activeTab : ''}`} onClick={() => setActiveTab(title)}>{title}</div>)}
                </div>

                <TableWrapper
                    headerDetails={userHeader}
                    pageMeta={metricList?.pageMeta}
                    handlePageChange={setPage}
                    listLength={metricList?.result || []}
                    isLoading={isLoading}
                    sortConfig={sortConfig}
                    setSortConfig={setSortConfig}
                >
                    {metricList?.result?.map((item) => {
                        const {
                            id,
                            redeemed_on,
                            delivery_address,
                            total_points,
                            user_details,
                            reward_details,
                        } = item;

                        // Combine first and last name
                        const userName = `${user_details?.firstName || ""} ${user_details?.lastName || ""}`.trim();

                        // Get reward titles
                        const rewardTitles = reward_details
                            ?.map((r) => r.title)
                            .join(", ");

                        const dateConvert = new Date(redeemed_on);
                        const monthName = dateConvert.toLocaleString('en-US', { month: 'long' });
                        let date = `${dateConvert.getDate()} ${monthName} ${dateConvert.getFullYear()}`;

                        return (
                            <tr key={id}>
                                {handleData(userName, "-", "text-center")}
                                {handleData(user_details?.email, "-", "text-center")}
                                {handleData(date, "-", "text-center")}
                                {handleData(delivery_address, "-", "text-center")}
                                {handleData(total_points, "-", "text-center")}
                                {handleData(rewardTitles, "-", "text-center")}
                            </tr>
                        );
                    })}
                </TableWrapper>
            </div>
        </div>
    );
};

export default RedeemedFirstTimeList;
